import ReactPlayer from 'react-player';

type EmbeddedVideoProps = {
	youTubeOrVimeoId: string;
	playing?: boolean;
	muted?: boolean;
	volume?: number; // 0..1
	loop?: boolean;
	controls?: boolean;
};

export const EmbeddedYouTubeOrVimeoVideo = ({
	youTubeOrVimeoId,
	playing = false,
	muted = true,
	volume = 1,
	loop = false,
	controls = true
}: EmbeddedVideoProps) => {
	// youtube IDs
	// 4AOzXIIAFcE
	// vhtRnMVgfH8

	// vimeo IDs
	// 831703290
	// 853599522

	// am just going to check to see if what's passed in can be resolved to a number; if so then assume it's Vimeo
	const isVimeo = /^\d+$/.test(youTubeOrVimeoId);
	const computedVolume = muted ? 0 : Math.max(0, Math.min(1, volume));

	const videoProps = {
		width: '100%',
		height: '100%',
		playing,
		muted,
		volume: computedVolume,
		loop,
		controls,
		playsinline: true
	};

	return (
		<div className="video-embed ratio ratio-16x9">
			{isVimeo ? (
				<ReactPlayer
					{...videoProps}
					url={`https://player.vimeo.com/video/${youTubeOrVimeoId}`}
					config={{
						vimeo: {
							playerOptions: {
								autoplay: playing,
								muted,
								loop,
								playsinline: true
							}
						}
					}}
				/>
			) : (
				<ReactPlayer
					{...videoProps}
					url={`https://www.youtube.com/embed/${youTubeOrVimeoId}`}
					config={{
						youtube: {
							playerVars: {
								autoplay: playing ? 1 : 0,
								mute: muted ? 1 : 0,
								playsinline: 1,
								controls: controls ? 1 : 0,
								rel: 0,
								modestbranding: 1
							}
						}
					}}
				/>
			)}
		</div>
	);
};
